import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useSwipeable } from 'react-swipeable';
//import coins from '../../assets/images/coins.png';
import Ai_refresh from '../../assets/icons/Ai_Loader.gif';
import { api } from '../../utils/apiRequest';
import circle from '../../assets/icons/circle.png';
import like from '../../assets/icons/lked.png';
import notlike from '../../assets/icons/not-liked.png';
import femalelogo from '../../assets/icons/ai-stylist-female.png';
import malelogo from '../../assets/icons/ai-stylist-male.png';
import life from '../../assets/icons/life.png';
import notfavorite from '../../assets/icons/favorite.png';
import favorite from '../../assets/icons/favoritselected.png';
import verified from '../../assets/icons/verified.png';
import location from '../../assets/icons/location.png';
import what from '../../assets/icons/whatt.png';
import vec from '../../assets/icons/vec.png';

export interface CollectiveItem {
  id: number;
  data: string;
  version: number;
  parentId: number | null;
  createdAt: string;
  images: string[];
  userId: number;
  children?: number | null;
  collective: boolean;
  likeCount: number | null;
  likeByCurrentUser: boolean;
  prof_pic: string;
  platForm?: string;
  coinUsed?: number;
  addedToFav?: boolean;
  favCount?: number;
  originId?: number;
  dressInfo?: { selectedOutfit?: string; gender?: string | null };
  userInfo?: {
    fullName?: string | null;
    profilePicture?: string | null;
    activeSuscription?: boolean;
  };
  address?: {
    id?: number;
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    lat?: number | null;
    lon?: number | null;
  };
  portfolioUserName?: string;
  sharedViaWhatsApp?: string;
  socialMedia?: {
    whatsapp?: string;
  };
}

interface CollectiveCardProps {
  item: CollectiveItem;
  onShowInfoChange?: (isShown: boolean) => void;
  setSelectlookbook?: React.Dispatch<React.SetStateAction<string>>;
}

const formatTimeline = (createdAt: string, platForm: any): string => {
  const createdDate = new Date(createdAt);
  const now = new Date();
  const diffMs = now.getTime() - createdDate.getTime();
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  const label = platForm === 'DARZEE' ? 'Brought to Life' : 'Prompt Created';

  if (diffHours < 1) {
    return `${label} - just now`;
  }

  if (diffDays < 1) {
    return `${label} - ${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  }

  if (diffDays < 30) {
    return `${label} - ${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  }

  const diffMonths = Math.floor(diffDays / 30);

  return `${label} - ${diffMonths} month${diffMonths !== 1 ? 's' : ''} ago`;
};

const CollectiveCard: React.FC<CollectiveCardProps> = ({
  item,
  onShowInfoChange,
  setSelectlookbook,
}) => {
  const outfitName = item.dressInfo?.selectedOutfit
    ? item.dressInfo.selectedOutfit.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    : 'Outfit';

  const designerName = item.userInfo?.fullName?.trim()
    ? item.userInfo.fullName.trim()
    : 'Unknown Designer';

  const getProfilePic = () => {
    const profilePic = item.userInfo?.profilePicture?.trim();
    const userGender = item.dressInfo?.gender?.toLowerCase() || '';

    if (profilePic) {
      return profilePic;
    }

    if (userGender === 'female') {
      return femalelogo;
    }

    if (userGender === 'male') {
      return malelogo;
    }

    // fallback if gender unknown
    return malelogo;
  };

  const [liked, setLiked] = useState(item.likeByCurrentUser);
  const [likeCount, setLikeCount] = useState(item.likeCount ?? 0);
  const [showInfo, setShowInfo] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [favorited, setFavorited] = useState(item.addedToFav ?? false);
  const [favCount, setFavCount] = useState(item.favCount ?? 0);
  const [whatsAppLoading, setWhatsAppLoading] = useState(false);

  const totalImages = item.images.length;

  const handleWhatsAppClick = (phoneNumber: string) => {
    if (!phoneNumber) {
      alert('WhatsApp number is not available');

      return;
    }

    // Clean number, add +91 if Indian 10-digit number (optional)
    let waNumber = phoneNumber.trim().replace(/\D/g, '');

    if (waNumber.length === 10 && !waNumber.startsWith('91')) {
      waNumber = '91' + waNumber;
    }

    const message = 'I need more information on this product. Could you assist?';
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${waNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleeWhatsAppClick = async () => {
    if (!item) {
      return;
    }
    setWhatsAppLoading(true);

    try {
      const body = {
        imageId: item.id,
        parameters: ['collective'],
      };

      const data = await api.postRequest('collective_link_share/generate', body);

      // eslint-disable-next-line no-console
      console.log('WhatsApp Link Response:', data);

      if (data?.data?.link) {
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(data?.data?.link)}`;
        window.open(whatsappUrl, '_blank');
      } else {
        // eslint-disable-next-line no-console
        console.error('No link returned from API');
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error generating WhatsApp link:', error);
    } finally {
      setWhatsAppLoading(false);
    }
  };

  useEffect(() => {
    setLiked(item.likeByCurrentUser);
    setLikeCount(item.likeCount ?? 0);
  }, [item.likeByCurrentUser, item.likeCount]);

  const setShowInfoAndNotify = (val: boolean) => {
    setShowInfo(val);
    onShowInfoChange?.(val);
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showInfo) {
      timer = setTimeout(() => setShowInfoAndNotify(false), 3000);
    }

    return () => clearTimeout(timer);
  }, [showInfo]);

  const handleFavoriteToggle = async () => {
    try {
      const token = localStorage.getItem('userToken') || '';
      const endpoint = favorited
        ? `fiza/collective/remove_from_fav?elementId=${item.id}`
        : `fiza/collective/add_to_fav?elementId=${item.id}`;

      const res = await api.putRequest(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data;
      // eslint-disable-next-line no-console
      console.log(data);

      // Optimistically update favorite count and state
      if (!favorited) {
        setFavCount((prev) => prev + 1);
      } else {
        setFavCount((prev) => Math.max(prev - 1, 0)); // Prevent negative counts
      }
      setFavorited(!favorited);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Error toggling favorite', err);
    }
  };

  const handleLikeToggle = async () => {
    try {
      const token = localStorage.getItem('userToken') || '';
      const endpoint = liked
        ? `fiza/collective/unlike_feed?elementId=${item.id}`
        : `fiza/collective/like_feed?elementId=${item.id}`;

      const res = await api.putRequest(endpoint, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = res.data;
      // eslint-disable-next-line no-console
      console.log(data);
      // Optimistically update like count
      setLikeCount((prev) => (liked ? Math.max(prev - 1, 0) : prev + 1));
      setLiked(!liked);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error toggling like', e);
    }
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? totalImages - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === totalImages - 1 ? 0 : prev + 1));
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNextImage,
    onSwipedRight: handlePrevImage,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const maxLength = 17;

  const truncateText = (text: string, maxLength: number): string => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }

    return text;
  };

  // const navigate = useNavigate();

  const formatAddress = (address?: {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    country?: string;
  }) => {
    if (!address) {
      return 'Location Not Available';
    }

    return [address.city, address.state, address.country].filter(Boolean).join(', ');
  };

  const handleOpenDesigner = (username: any) => {
    localStorage.setItem('selected_tab', 'lookbook');
    localStorage.setItem('username', username);
    localStorage.setItem('selectlookbook', 'Explore Designers');
    setSelectlookbook?.('Explore Designers'); // safe call
  };

  return (
    <motion.div
      className={`relative flex flex-col md:flex-row bg-white shadow-md hover:shadow-lg mx-auto w-full max-w-[95%] md:mt-2 ${
        showInfo ? ' bg-black bg-opacity-25' : ''
      } rounded-[30px] border-2 border-[#F3D7AC] p-0 sm:p-5 sm:mx-auto`}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* Circle Button only visible on phone */}
      <button
        onClick={() => setShowInfoAndNotify(true)}
        className="md:hidden absolute top-6 right-[30px] z-20"
      >
        <img src={circle} alt="Info" className="h-5 w-5" />
      </button>

      {/* Mobile Animated Overlay */}
      <AnimatePresence>
        {showInfo && (
          <>
            {/* DESIGNED BY + Location + Actions */}
            <motion.div
              initial={{ x: '100%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: '100%', opacity: 0 }}
              transition={{ duration: 0.6 }}
              className="absolute top-6 right-[20px] -translate-x-1/2 text-white w-3/4 max-w-xs min-w-[230px] bg-[linear-gradient(90deg,rgba(179,156,122,0.67)_0%,rgba(179,156,122,0.268)_100%)] rounded-xl px-4 py-3 text-sm font-medium shadow-md md:hidden"
              style={{ zIndex: 10 }}
            >
              <div className="text-xs uppercase tracking-wide opacity-80">DESIGNED BY</div>
              <div className="flex items-center gap-1 mt-1">
                <img
                  src={getProfilePic()}
                  alt="Profile"
                  className="w-5 h-5 rounded-full object-cover"
                />
                <span className="font-semibold text-white text-xs">
                  {truncateText(designerName, maxLength)}
                </span>
                {item.userInfo?.activeSuscription && (
                  <img src={verified} alt="verified" className="w-3 h-3" />
                )}
              </div>
              {item.platForm === 'DARZEE' && (
                <div className="flex items-center gap-1 mt-1 text-xs text-white/80">
                  <img src={location} alt="location" className="w-4 h-4" />
                  <span>{formatAddress(item.address)}</span>
                </div>
              )}
              {item.platForm === 'DARZEE' && (
                <div className="flex items-center gap-2 mt-2">
                  <button
                    onClick={() => handleOpenDesigner(item?.portfolioUserName)}
                    className="flex items-center gap-1 bg-[#5C3B94] text-white text-xs px-3 py-1 rounded-full hover:bg-[#4b2f7e] transition"
                  >
                    <img src={vec} alt="vector icon" className="w-4 h-4" />
                    View More
                  </button>
                  <button
                    onClick={() =>
                      handleWhatsAppClick(
                        item.socialMedia?.whatsapp || item.sharedViaWhatsApp || ''
                      )
                    }
                    disabled={whatsAppLoading}
                    className="bg-green-500 text-white text-xs px-3 py-1 rounded-full flex items-center gap-1 hover:bg-green-600 transition disabled:opacity-70"
                  >
                    {whatsAppLoading ? (
                      <>
                        <svg
                          className="animate-spin h-3 w-3 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                          ></path>
                        </svg>
                        <span>Sending</span>
                      </>
                    ) : (
                      <>
                        <img src={what} alt="WhatsApp" className="w-4 h-4" />
                        WhatsApp
                      </>
                    )}
                  </button>
                </div>
              )}
            </motion.div>
            {/* TIMELINE - spacing varies by platform */}
            <motion.div
              initial={{ x: '100%', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: '100%', opacity: 0 }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="absolute right-[20px] -translate-x-1/2 text-white w-3/4 max-w-xs min-w-[230px] bg-[linear-gradient(90deg,rgba(179,156,122,0.67)_0%,rgba(179,156,122,0.268)_100%)] rounded-xl px-4 py-2 text-sm font-medium shadow-md md:hidden"
              style={{
                top:
                  item.platForm === 'DARZEE'
                    ? 'calc(6rem + 80px)' // spacing for DARZEE
                    : 'calc(6rem)', // spacing for FIZA
              }}
            >
              <div className="text-xs uppercase tracking-wide opacity-80">TIMELINE</div>
              <div className="font-normal text-white">
                {formatTimeline(item.createdAt, item.platForm)}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>

      {/* Left side */}
      <motion.div
        className="flex flex-col items-center md:items-start rounded-[30px] p-[10px]"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <div
          className="w-full h-[70vh] md:h-[60vh] flex items-start  justify-center overflow-hidden rounded-[30px] md:rounded-[30px]  "
          {...(window.innerWidth < 768 ? handlers : {})}
        >
          {/* Slider Controls (Desktop) */}
          {totalImages > 1 && (
            <>
              <button
                onClick={handlePrevImage}
                aria-label="Previous Image"
                className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 text-white bg-black/30 hover:bg-black/50 rounded-full p-2 z-10"
              >
                &#8249;
              </button>
              <button
                onClick={handleNextImage}
                aria-label="Next Image"
                className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 text-white bg-black/30 hover:bg-black/50 rounded-full p-2 z-10"
              >
                &#8250;
              </button>
            </>
          )}

          <img
            src={item.images[currentImageIndex]}
            alt={`${outfitName} - Image ${currentImageIndex + 1}`}
            className="object-fill h-full"
          />
          {/* Mobile Dots Above Image */}
          {totalImages > 1 && (
            <div className="flex justify-center gap-3 md:hidden absolute bottom-6 left-1/2 -translate-x-1/2 z-30">
              {item.images.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentImageIndex(index)}
                  className={`w-3 h-3 rounded-full  ${
                    index === currentImageIndex ? 'bg-gray-500' : 'bg-gray-400'
                  }`}
                />
              ))}
            </div>
          )}
        </div>

        <div className="hidden md:flex items-center gap-4 mt-4 text-base sm:text-sm md:text-xl font-semibold">
          <span> {truncateText(outfitName, maxLength)}</span>
          <button
            type="button"
            aria-label={liked ? 'Unlike' : 'Like'}
            onClick={handleLikeToggle}
            className="flex items-center gap-1 text-black focus:outline-none"
          >
            {liked ? (
              <img src={like} alt="Like Icon" className="h-5 w-auto" />
            ) : (
              <img src={notlike} alt="Unlike Icon" className="h-5 w-auto" />
            )}
            <span className="font-bold hidden md:block">{likeCount}</span>
          </button>
          <button
            type="button"
            aria-label={favorited ? 'Remove from Favorites' : 'Add to Favorites'}
            onClick={handleFavoriteToggle}
            className="flex items-center gap-1 text-black focus:outline-none"
          >
            {favorited ? (
              <img src={favorite} alt="Favorited" className="h-5 w-auto" />
            ) : (
              <img src={notfavorite} alt="Not Favorited" className="h-5 w-auto" />
            )}
            <span className="font-medium ">{favCount}</span>
          </button>

          <>
            <img
              onClick={handleeWhatsAppClick}
              src={what}
              alt="whatsapp"
              className="h-5 w-auto cursor-pointer "
            />
            <span className="text-sm font-medium">{item.sharedViaWhatsApp}</span>
          </>
        </div>

        <div className="md:flex items-center gap-5 mt-3 hidden ">
          <span
            className={`${
              item.platForm === 'DARZEE'
                ? 'bg-green-100 text-green-700'
                : 'bg-purple-100 text-purple-700'
            } text-[10px] font-bold rounded-full flex items-center gap-1 px-2 py-0.5`}
          >
            {item.platForm === 'DARZEE' ? (
              <>
                <img src={life} alt="brought to life" className="h-4" />
                Brought to Life
              </>
            ) : (
              <>
                <img src={Ai_refresh} alt="AI Refresh" className="h-4" />
                AI
              </>
            )}
          </span>
        </div>
      </motion.div>

      {/* Right side (only desktop) */}
      <motion.div
        className="hidden md:flex flex-1 flex-col justify-start mt-6 md:mt-0 md:pl-32"
        initial={{ opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        <div className="flex flex-col gap-6 md:mt-4">
          {/* Designer */}
          <div>
            <div className="font-semibold text-[10px] sm:text-[11px] text-gray-500 tracking-wide">
              DESIGNED BY
            </div>
            <div className="flex items-center gap-2 mt-1">
              <img
                src={getProfilePic()}
                alt="Profile"
                className="w-7 h-7 sm:w-8 sm:h-8 rounded-full object-cover"
              />

              <span className="text-sm text-purple-700 font-medium cursor-pointer hover:underline">
                {designerName}
              </span>
            </div>
          </div>

          {/* Timeline */}
          <div>
            <div className="font-semibold text-[10px] sm:text-[11px] text-gray-500 tracking-wide">
              TIMELINE
            </div>
            <div className="text-xs sm:text-sm text-gray-700 mt-1 flex items-start gap-2">
              <span className="text-lg leading-none">•</span>
              <span> {formatTimeline(item.createdAt, item.platForm)}</span>
            </div>
          </div>
          {item.platForm === 'DARZEE' && (
            <div className="flex items-center gap-2 mt-2">
              <button
                onClick={() => handleOpenDesigner(item?.portfolioUserName)}
                className="flex items-center gap-1 bg-[#5C3B94] text-white text-xs px-3 py-1 rounded-full hover:bg-[#4b2f7e] transition "
                style={{ height: '40px', minWidth: '120px' }}
              >
                <img src={vec} alt="vector icon" className="w-4 h-4" />
                View More
              </button>
              <button
                onClick={() =>
                  handleWhatsAppClick(item.socialMedia?.whatsapp || item.sharedViaWhatsApp || '')
                }
                disabled={whatsAppLoading}
                className="bg-green-500 text-white text-xs px-3 py-1 rounded-full flex items-center gap-1 hover:bg-green-600 transition disabled:opacity-70"
                style={{ height: '40px', minWidth: '120px' }}
              >
                {whatsAppLoading ? (
                  <>
                    <svg
                      className="animate-spin h-3 w-3 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      ></path>
                    </svg>
                    <span>Sending</span>
                  </>
                ) : (
                  <>
                    <img src={what} alt="WhatsApp" className="w-4 h-4" />
                    WhatsApp
                  </>
                )}
              </button>
            </div>
          )}
        </div>
      </motion.div>

      {/* Mobile Bottom Bar */}

      {/* Mobile Bottom Bar */}
      <div className="md:hidden px-4 pb-3 bg-white rounded-b-[30px] shadow-md">
        <div className="flex items-center justify-between w-full px-2 text-sm">
          <span className="font-semibold text-base truncate">
            {' '}
            {truncateText(outfitName, maxLength)}
          </span>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <>
                <img
                  onClick={handleeWhatsAppClick}
                  src={what}
                  alt="whatsapp"
                  className="h-5 w-auto cursor-pointer "
                />
                <span className="text-sm font-medium">{item.sharedViaWhatsApp}</span>
              </>
            </div>
            <button
              type="button"
              aria-label={liked ? 'Unlike' : 'Like'}
              onClick={handleLikeToggle}
              className="flex items-center gap-1 text-black focus:outline-none"
            >
              {liked ? (
                <img src={like} alt="Like Icon" className="h-5 w-auto" />
              ) : (
                <img src={notlike} alt="Unlike Icon" className="h-5 w-auto" />
              )}
              <span className="font-medium">{likeCount}</span>
            </button>
            <button
              type="button"
              aria-label={favorited ? 'Remove from Favorites' : 'Add to Favorites'}
              onClick={handleFavoriteToggle}
              className="flex items-center gap-1 text-black focus:outline-none"
            >
              {favorited ? (
                <img src={favorite} alt="Favorited" className="h-5 w-auto" />
              ) : (
                <img src={notfavorite} alt="Not Favorited" className="h-5 w-auto" />
              )}
              <span className="font-medium ">{favCount}</span>
            </button>
          </div>
        </div>

        <div className="flex items-center gap-1 px-2">
          <span
            className={`${
              item.platForm === 'DARZEE'
                ? 'bg-green-100 text-green-700'
                : 'bg-purple-100 text-purple-700'
            } text-[10px] font-bold rounded-full flex items-center gap-1 px-2 py-0.5`}
          >
            {item.platForm === 'DARZEE' ? (
              <>
                <img src={life} alt="brought to life" className="h-4" />
                Brought to Life
              </>
            ) : (
              <>
                <img src={Ai_refresh} alt="AI Refresh" className="h-4" />
                AI
              </>
            )}
          </span>
        </div>
      </div>
    </motion.div>
  );
};

export default CollectiveCard;
